import React, { Component } from 'react';
import TimePicker from 'material-ui/TimePicker';
import { createMuiTheme } from '@material-ui/core';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import MuiPickersUtilsProvider from 'material-ui-pickers/utils/MuiPickersUtilsProvider';
import MomentUtils from 'material-ui-pickers/utils/moment-utils';
import moment from 'moment';
import orange from '@material-ui/core/colors/orange';

import getMuiTheme from 'material-ui/styles/getMuiTheme';

const customTheme = {
  palette: {
    primary1Color: '#f99e60',
    primary2Color: '#f99e60',
    primary3Color: '#f99e60',
    pickerHeaderColor: '#f99e60',
    clockCircleColor: '#ffffff'
  }
};
//let testRef = null;
class TimePickerFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value24: null,
      value12: props.first ? new Date() : null,
      style: {
        width: '92px',
        height: '24px',
        fontSize: '12px',
        color: '#ccc',
        backgroundColor: 'white',
        headerColor: 'red'
      },
      time: new Date(),
      clearRow: false
    };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.clearRow == true) {
      //  this.handleClearInput();
      //  this.setState({ time: null });
      this.setState({
        time: null,
        value12: null
        //clearRow: nextProps.clearRow
      });
    }
  }
  // componentDidUpdate(prevProps, prevState) {
  //   if (prevProps.clearRow != prevState.clearRow) {
  //     this.setState({ time: null });
  //   }
  // }
  // handleChangeTimePicker24 = (event, date) => {
  //   this.setState({ value24: date });
  // };

  handleChangeTimePicker12 = (event, date) => {
    this.setState({ value12: date });
    this.props.handleSubmitTime({ id: this.props.id, value: date });
  };

  render() {
    return (
      <MuiThemeProvider muiTheme={getMuiTheme(customTheme)}>
        <TimePicker
          format="ampm"
          hintText=""
          value={this.props.time ? this.props.time : this.state.value12}
          onChange={this.handleChangeTimePicker12}
          textFieldStyle={this.state.style}
          autoOk={true}
          underlineShow={false}
          show="true"
          id="time-picker"
          dialogBodyStyle={{
            backgroundColor: '#ffffff'
          }}
          inputStyle={{
            paddingLeft: '5px',
            color: '#ccc',
            fontFamily: 'latoregular',
            border: '1px solid #ccc'
          }}
          ref={ref => (this.testRef = ref)}
        />
      </MuiThemeProvider>
    );
  }
}

export default TimePickerFilter;



// WEBPACK FOOTER //
// ./source/client/components/allocator/timePicker.jsx